window.HiddenGemsAppraisal = (function() {

  var Appraisal, Gem, appraise, attachEvents, cdnFileUrl, chunkArray, findByTagCode, getTagCodeFromQuery, init,
      rawData, sampleShopifyFileUrl, showUnknownCodeError, validateTagCode, twitterImageUrl, facebookImageUrl;

  rawData = {};
  sampleShopifyFileUrl = '';

  twitterImageUrl   = '//cdn.shopify.com/s/files/1/0543/4293/files/twitter-white.png';
  facebookImageUrl = '//cdn.shopify.com/s/files/1/0543/4293/files/facebook-white.png';

  Appraisal = (function() {
    function Appraisal(tagCode1, attr) {
      var num;
      this.tagCode = tagCode1;
      this.gemCount = attr.gem_count;
      this.value = attr.appraisal_value;
      this.gems = (function() {
        var i, ref, results;
        results = [];
        for (num = i = 1, ref = this.gemCount; 1 <= ref ? i <= ref : i >= ref; num = 1 <= ref ? ++i : --i) {
          results.push(new Gem(attr, num));
        }
        return results;
      }).call(this);
    }

    Appraisal.prototype.renderPage = function() {
	  var gemValue = this.value.toFixed(0)
      $('#ring_code').html(this.tagCode);
      $('#appraised_value').html('$' + gemValue);
      $('.appraisal-block').fadeIn();

      $('.rings').append(this.gems.map(function(gem) {
		return gem.createHtml(gemValue);
      }));
    };

    return Appraisal;

  })();

  Gem = (function() {
    function Gem(attr, index) {
      this.index = index;
      this.type = attr.gem_type;
      this.categoryCode = attr.gem_category_code;
      this.hasCertificate = attr.has_appraisal_certificate;
      this.basename = ['hidden-gems', this.categoryCode, this.type, this.index].join('-');
    }

    Gem.prototype.imgSrc = function(sizeParams) {
      sizeParams = sizeParams ? '_' + sizeParams : '';
      return cdnFileUrl(this.basename + sizeParams + '.jpg');
    };

    Gem.prototype.certificateSrc = function() {
      return (this.hasCertificate && cdnFileUrl(this.basename + '.pdf')) || '';
    };


    Gem.prototype.socialSharing = function() {

      /* TODO */
    };

    Gem.prototype.createHtml = function(gemValue) {
      var html, shareText, fbShareHref, fbShareText;
      shareText = "Yay! I+just+revealed+a+stunning+$"+ gemValue +"+%23HiddenGems+" + this.type + ".+You+can+too!+Discover+yours+at+http://HiddenGems.ca+from+@ShopAtShowcase"
      fbShareText = "Yay! I+just+revealed+a+stunning+$"+ gemValue +"+%23HiddenGems+" + this.type + ".+You+can+too!+Discover+yours+at+www.HiddenGems.ca+from+@ShopAtShowcase"
      fbShareHref = "https://www.facebook.com/dialog/feed?"
      fbShareHref += "app_id=775357062624005"
      fbShareHref += "&link=https://ca.shopatshowcase.com/pages/hidden-gems"
      fbShareHref += "&quote=" + fbShareText
      fbShareHref += "&redirect_url=https://ca.shopatshowcase.com/pages/hidden-gems"

      html = "<div class= 'col-md-4 col-sm-6 col-xs-12'>"
      html += "<div class='appraised-jewelry'><img src='" + (this.imgSrc('256x256')) + "' alt=''>";
      html += "<div class='jewelry-details'>";
      if (this.hasCertificate) {
        html += "<div class='certificate'><a href='" + (this.certificateSrc()) + "' target='_blank'>See Appraisal Certificate</a> <hr></div>";
      }

      html += "<div class='social-links'>"
      html += "<p>Share Your Reveal </p>"
      html += "<a class='fb-share' href='" + fbShareHref + "' target='_blank'><img src="+ facebookImageUrl +"></a>"
      html += "<a href='http://twitter.com/intent/tweet?text="+ shareText +"' target='_blank'><img src="+ twitterImageUrl +"></a>"
      html += "</div></div></div></div>"

      return html;
    };

    return Gem;

  })();

  findByTagCode = function(tagCode) {
    var appraisalData, i, len;
    tagCode = tagCode.toUpperCase();
    for (i = 0, len = rawData.length; i < len; i++) {
      appraisalData = rawData[i];
      if (appraisalData.gem_tag_code.indexOf(tagCode) !== -1) {
        return new Appraisal(tagCode, appraisalData);
      }
    }
    return false;
  };

  showUnknownCodeError = function(form) {
    var $error;
    $error = $('.error', form);
    if (!$error.length) {
      $error = $('<div class="error"></div>').insertBefore($('input', form).first());
    }
    return $error.html('Invalid code.');
  };

  validateTagCode = function(event) {
	var currentLocation;
    if (findByTagCode(this.gem_tag_code.value)) {
      return true;
    } else {
      showUnknownCodeError(this);
      return false;
    }
  };

  getTagCodeFromQuery = function() {
    var match;
    match = /gem_tag_code=([^?&]+)/.exec(location.search);
    return match && match[1];
  };


  cdnFileUrl = function(filename) {
    return sampleShopifyFileUrl.replace(/[^\/]+(\?.*)$/, filename + '$1');
  };

  attachEvents = function() {
    $('a[href="#appraisal"]').on('click', function() {
      lity('#appraisal-modal');
      return false;
    });
    $('#appraisal_form').on('submit', validateTagCode);
    $('#appraisal-modal').on('lity:ready', function(event, lityInstance) {
      $('input', this).first().focus();
    });
  };

  appraise = function() {
    var appraisal, tagCode;
    tagCode = getTagCodeFromQuery();
    appraisal = findByTagCode(tagCode);
    if (appraisal) {
      appraisal.renderPage();
    } else {
      $('a[href="#appraisal"]').first().click();
      if (tagCode) {
        var $form = $('#appraisal_form');
        $form.find('input').val(tagCode);
        showUnknownCodeError($form);
      }
    }
  };

  init = function(fileUrl, data) {
    sampleShopifyFileUrl = fileUrl;
    rawData = data;
    return $(attachEvents);
  };

  return {
    init: init,
    appraise: appraise
  };

})();
